// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tech-specs-footer[data-v-030671cb] {\r\n  border: none;\r\n  background-color: white;\n}\r\n", ""]);
// Exports
module.exports = exports;
